export default __webpack_public_path__ + "static/media/management.636f9c7b35f32ea0139474ba2b15dd24.svg";